
import React from 'react';
import { Check } from "lucide-react";

const ServicePackage = () => {
  return (
    <section id="benefits" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-dark">Unser Komplettpaket</h2>
          <p className="text-grey text-lg max-w-3xl mx-auto">
            Wir bieten dir eine Rundum-Lösung für deine eigene KI-Plattform – 
            von der Installation bis zur professionellen Einweisung.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="text-primary" size={14} />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-dark">Installation und Konfiguration</h3>
                  <p className="text-grey">
                    Wir übernehmen die komplette Einrichtung der gesamten Infrastruktur auf deinen Servern, 
                    inklusive aller notwendigen Komponenten und Anpassungen.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="text-primary" size={14} />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-dark">2-stündiger Videokurs</h3>
                  <p className="text-grey">
                    Ein umfassender Videokurs zu Data/AI für deine Mitarbeiter, 
                    damit sie das volle Potenzial deiner neuen KI-Plattform ausschöpfen können.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="text-primary" size={14} />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-dark">Microsoft-Benutzerverwaltung</h3>
                  <p className="text-grey">
                    Nahtlose Anbindung an deine bestehende Microsoft-Benutzerverwaltung 
                    für eine einfache Integration in deine Unternehmensstruktur.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="text-primary" size={14} />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-dark">Professionelle Einweisung</h3>
                  <p className="text-grey">
                    Umfassende Schulung deiner IT-Abteilung in die Nutzung der Ressourcen 
                    und alle Aspekte der neuen KI-Plattform.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-secondary rounded-2xl p-8 shadow-custom">
            <h3 className="text-2xl font-bold mb-6 text-dark">Zukunftssicher</h3>
            <p className="text-grey mb-8">
              In weiteren Projektphasen unterstützen wir dich bei der kontinuierlichen Weiterentwicklung 
              und Optimierung deiner KI-Plattform:
            </p>
            
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Check className="text-primary" size={14} />
                </div>
                <span className="text-grey">Anbinden deiner internen Wissensdatenbanken</span>
              </li>
              
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Check className="text-primary" size={14} />
                </div>
                <span className="text-grey">Integration in bestehende Unternehmensprozesse</span>
              </li>
              
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Check className="text-primary" size={14} />
                </div>
                <span className="text-grey">Anpassung der Modelle an deine spezifischen Anforderungen</span>
              </li>
              
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Check className="text-primary" size={14} />
                </div>
                <span className="text-grey">Fortlaufende Optimierung und Weiterentwicklung</span>
              </li>
            </ul>
            
            <div className="mt-8 p-4 bg-white rounded-xl border border-primary/10">
              <p className="text-center text-grey font-medium">
                Alle Daten bleiben zu 100% auf deinen Servern – volle Kontrolle, maximale Sicherheit
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicePackage;
